import sortBy from 'lodash/sortBy';

export const createStringValueFromObject = (values: { value: number; label: string }[] = []) => {
  return JSON.stringify(
    Object.values(values).reduce((acc, obj, i) => {
      acc[i] = obj.value;
      return acc;
    }, {} as { [key: number]: number })
  );
};

export const createCustomerType = async (
  customerType: string
): Promise<AutocompleteOption | null> => {
  if (!customerType.trim()) {
    window.alertUser("Customer type can't be empty");
    return null;
  }
  try {
    const response = await window.fetch(
      `/API/V3/Account/${window.merchantos.account.id}/CustomerType.json`,
      {
        body: JSON.stringify({
          name: customerType,
        }),
        headers: {
          'Content-Type': 'text/json',
        },
        method: 'POST',
      }
    );
    const {
      CustomerType: { customerTypeID, name },
    } = await response.json();

    return { value: customerTypeID, label: name };
  } catch (error) {
    window.alertUser('Customer type creation failed');
  }
  return null;
};

export const searchCustomerTypes = async (search: string) => {
  const response = await fetch(
    `/API/V3/Account/${window.merchantos.account.id}/CustomerType.json?name=~,${search}%&limit=100`
  );

  let apiCustomerTypes: CustomerTypeFromAPI[] = [];
  let customerTypes: AutocompleteOption[] = [];
  try {
    ({ CustomerType: apiCustomerTypes } = await response.json());

    if (apiCustomerTypes && !(apiCustomerTypes instanceof Array)) {
      apiCustomerTypes = [apiCustomerTypes];
    }

    customerTypes = sortBy(
      apiCustomerTypes.map(({ name, customerTypeID }) => ({
        value: parseInt(customerTypeID, 10),
        label: name,
      })),
      ['label']
    );
  } catch (err) {
    // Error parsing the API response
  }

  return customerTypes;
};
